

import { Login } from '@/models/login'
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import Book from "@/models/book.models";
import BookRepository from "@/services/BookRepository";
import router from "@/router";
import {useStore} from "vuex";
import {Team} from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";

export default {
  props: {
    id: Number,
  },
  setup(props){
    const login = ref({} as Login);
    const toast = useToast();
    const updateBook = ref({} as Book);

    const valid = computed(()=> updateBook.value.team);
    const teams = ref({} as Team[]);

      TeamRepository.getTeams()
          .then((response) => {
              teams.value = response.data;
          })
          .catch();

      const store = useStore();
      if(store.state.token == ""){
          router.push({
              name: 'home'
          });
      }

      BookRepository.getById(props.id)
          .then(response => {
              updateBook.value = response.data;
          })
          .catch(() => {
              toast.add({
                  severity: 'error',
                  summary: 'Thất bại',
                  detail: 'Không thể tải danh sách lịch đặt chổ.',
                  life: 2000
              });
          })
          .finally(() => {
          });

      const changeTeam = () => {
          BookRepository.updateBook(updateBook.value)
              .then(response => {
                  toast.add({
                      severity: 'success',
                      summary: 'Thành Công',
                      detail: 'Chuyển khoa cho bệnh nhân thành công.',
                      life: 2000
                  });
                  router.push({
                      name: 'home',
                  });
              })
              .finally(()=>{
              });
      };
      const getDay = () => {
          let day = "";
          console.log("############################### Get Day AAA: " + updateBook.value.day);
          switch (updateBook.value.day) {
              case "Sunday":
                  day = "Chủ nhật";
                  break;
              case "Monday":
                  day = "Thứ hai";
                  break;
              case "Tuesday":
                  day = "Thứ ba";
                  break;
              case "Wednesday":
                  day = "Thứ tư";
                  break;
              case "Thursday":
                  day = "Thứ năm";
                  break;
              case "Friday":
                  day = "Thứ sáu";
                  break;
              case "Saturday":
                  day = "Thứ bảy";
          }
          console.log("############################### Get Day BBB: " + day);
          return day;
      };

    return {
      login,
      updateBook,
      valid,
      teams,
      changeTeam,
      getDay
    }
  }
}

